import firebase from 'firebase/app'
import 'firebase/firestore'

const firebaseConfig = {
    apiKey: "AIzaSyAyD4-3m3nVEW9Fbql4ho0CRmRqpDKeoYo",
    authDomain: "prod-imlca.firebaseapp.com",
    databaseURL: "https://prod-imlca.firebaseio.com",
    projectId: "prod-imlca",
    storageBucket: "prod-imlca.appspot.com",
    messagingSenderId: "1018423316611"
  };

export const firebaseApp = firebase.initializeApp(firebaseConfig);

export const db = firebaseApp.firestore()